import {Box, styled} from '@mui/material';

export const CircularButton = styled(Box)(({theme}) => ({
  width: theme.spacing(5),
  height: theme.spacing(5),
  borderRadius: '50%',
  border: `${theme.spacing(0.125)} solid ${theme.palette.grey[100]}`,
  backgroundColor: theme.palette.common.mds_global_color_white,
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  zIndex: 1,
  position: 'absolute',
  top: 0,
  bottom: 0,
  margin: 'auto',
  boxShadow: `0 0 ${theme.spacing(3.333)} 0 rgba(0, 0, 0, 0.24)`
}));

export const HorizontalScrollerContainer = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  position: 'relative'
}));

export const HorizontalScrollerWrapper = styled(Box)(() => ({
  height: '100%',
  position: 'relative',
  overflow: 'hidden'
}));

export const HorizontalScrollerContent = styled(Box)(() => ({
  display: 'flex',
  scrollbarWidth: 'none',
  overflowY: 'hidden',
  whiteSpace: 'nowrap',
  overflowX: 'auto',
  scrollSnapType: 'x mandatory',
  scrollBehavior: 'smooth',
  '& > div': {
    scrollSnapAlign: 'start',
    flex: 'none'
  },
  '&::-webkit-scrollbar': {
    display: 'none'
  }
}));

export const LeftCircularArrowButton = styled(CircularButton)(() => ({
  left: -10,
  '&.brandCarousel': {
    left: 0
  }
}));

export const RightCircularArrowButton = styled(CircularButton)(({theme}) => ({
  right: -10,
  '&.brandCarousel': {
    right: 0
  },
  '&.seeAll': {
    position: 'relative',
    left: 0,
    width: theme.spacing(7),
    height: theme.spacing(7),
    display: 'flex'
  }
}));

export const ArrowHolder = styled(Box)(({theme}) => ({
  height: '100%',
  position: 'absolute',
  width: theme.spacing(6.875),
  top: 0
}));

export const LeftArrowHolder = styled(ArrowHolder)(({theme}) => ({
  left: 0,
  backgroundImage: `linear-gradient(270deg, hsla(0, 0%, 100%, 0), ${theme.palette.common.mds_global_color_white})`
}));

export const RightArrowHolder = styled(ArrowHolder)(({theme}) => ({
  right: 0,
  backgroundImage: `linear-gradient(90deg, hsla(0, 0%, 100%, 0), ${theme.palette.common.mds_global_color_white})`
}));

export const SeeAllContainer = styled(Box)(({theme}) => ({
  height: 'inherit',
  backgroundColor: theme.palette.common.mds_global_color_white,
  display: 'inline-flex',
  whiteSpace: 'nowrap',
  flexDirection: 'column',
  border: `${theme.spacing(0.125)} solid ${theme.palette.grey[100]}`,
  borderRadius: theme.spacing(2)
}));

export const SeeAllWrapperContainer = styled(Box)(({theme}) => ({
  width: theme.spacing(13.5),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer'
}));

export const SeeAllInnerWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));

export const SeeAllText = styled(Box)(({theme}) => ({
  fontSize: theme.spacing(2),
  lineHeight: theme.spacing(3),
  marginTop: theme.spacing(1)
}));
